import { computed } from 'vue'

/**
 * Composable pour gérer l'état dérivé de QuoteDetailPage
 * Limite: 30 lignes max
 */
export function useQuoteDetailPageState(quote) {
  const isQuoteSigned = computed(() => {
    if (!quote.value) return false
    const status = quote.value.status
    return Boolean(quote.value?.signature_date) ||
           Boolean(quote.value?.signatureDate) ||
           status === 'devis_signe' ||
           status === 'demande_perdue' ||
           status === 'devis_perdu' ||
           status === 'encode_digiforma'
  })

  return {
    isQuoteSigned
  }
}
